document.addEventListener('DOMContentLoaded', function() {
    // 1. Detect In-App Browsers
    var ua = navigator.userAgent || '';
    var isIG = /Instagram|Barcelona/i.test(ua);
    var isFB = /FBAN|FBAV|FB_IAB|Messenger/i.test(ua);
    var isInApp = isIG || isFB;
    var isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    var isAndroid = /Android/i.test(ua);

    if (!isInApp) return; // Exit if user is in a regular browser like normal Safari/Chrome

    // 2. Target your App Store download link
    // Replace the selector below if your button has a specific class or ID (e.g., '.app-store-btn')
    var appLinks = document.querySelectorAll('a[href*="apps.apple.com"], a[href*="play.google.com"], .app-download-link');

    appLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault(); // Stop Instagram from ignoring the tap
        var targetUrl = link.getAttribute('href');

        if (isIOS) {
          if (isIG) {
            // Forces Instagram iOS to break out directly into native Safari
            window.location.href = 'instagram://extbrowser/?url=' + encodeURIComponent(targetUrl);
          } else if (isFB) {
            // Forces Facebook iOS to break out into Safari
            window.open('x-safari-' + targetUrl, '_blank');
          } else {
            window.location.href = targetUrl;
          }
        } else if (isAndroid) {
          // Forces Android in-app browsers to open default browser (Chrome)
          var urlNoScheme = targetUrl.replace(/^https?:\/\//i, '');
          window.location.href = 'intent://' + urlNoScheme + '#Intent;scheme=https;end';
        } else {
          window.location.href = targetUrl;
        }
      });
    });
});